import React from "react";
import { Screen } from '~common/screen';
import { StyledScreen } from '~common/screen';
import { Styled } from './styled'
import ArrowIcon from '~images/step-arrow.svg'
import ArrowIconBottom from '~images/step-arrow-bottom.svg'
import CheckIcon from '~images/check.svg'

const SetupStepsScreen = () => {
  const steps = [
    {
      title: 'Регистрация',
      text: 'Вы регистрируетесь в сервисе.',
      color: '#FAE4F5'
    },
    {
      title: 'Звонок менеджера',
      text: <span>Наш менеджер свяжется с вами в течение <strong>10 минут</strong> и уточнит потребности.</span>,
      color: '#CFEFF8'
    },
    {
      title: 'Выбор времени',
      text: 'Вместе с менеджером вы выберете удобное время для настройки АТС.',
      color: '#E6E8FF'
    },
    {
      title: 'Удаленная настройка',
      text: <span>С вами свяжется сотрудник техподдержки, и за <strong>20 минут</strong> удаленно настроит АТС.</span>,
      color: '#B3EEE2'
    }
  ]

  return (
    <Screen
      id='settings'
      title={<span>Не хотите разбираться в <StyledScreen.GreenText>настройках</StyledScreen.GreenText> телефонии?</span>}
      subTitle='И не нужно — мы сделаем всё за вас. Бесплатно.'
      bottomLine={true}
    >
      <Styled.Container>
        <Styled.StepsLine>
          {
            steps.map((step, index) => (
              <>
                {
                  (index + 1) % 2 === 0
                    ? (
                      <Styled.StepEven>
                        <Styled.StepInfo color={step.color}>
                          <Styled.StepTitle>{step.title}</Styled.StepTitle>
                          <Styled.StepText>{step.text}</Styled.StepText>
                        </Styled.StepInfo>
                        <Styled.StepIcon>{index + 1}</Styled.StepIcon>
                        <Styled.MobileStepArrow><ArrowIconBottom /></Styled.MobileStepArrow>
                      </Styled.StepEven>
                    )
                    : (
                      <Styled.StepOdd>
                        <Styled.StepInfo color={step.color}>
                          <Styled.StepTitle>{step.title}</Styled.StepTitle>
                          <Styled.StepText>{step.text}</Styled.StepText>
                        </Styled.StepInfo>
                        <Styled.StepIcon>{index + 1}</Styled.StepIcon>
                        <Styled.MobileStepArrow><ArrowIconBottom /></Styled.MobileStepArrow>
                      </Styled.StepOdd>
                    )
                }
                {
                  index + 1 !== steps.length &&
                  <Styled.StepArrow><ArrowIcon /></Styled.StepArrow>
                }
              </>
            ))
          }
        </Styled.StepsLine>
        <Styled.FinalStep>
          <Styled.FinalStepHeader>
            <Styled.StepTitle>АТС работает!</Styled.StepTitle>
            <Styled.CheckIcon><CheckIcon /></Styled.CheckIcon>
          </Styled.FinalStepHeader>
          <Styled.StepText>В течение суток вы получите полностью готовую к работе АТС.</Styled.StepText>
        </Styled.FinalStep>
      </Styled.Container>
    </Screen>
  )
}

export { SetupStepsScreen }
